export const downgradeTitle = 'License Downgrade';

export const downgradeText = 'Your active user count exceeds the number allowed by your account.';
